export default "__VITE_ASSET__86066f4b__"